import { render, staticRenderFns } from "./company_detail_base.vue?vue&type=template&id=3fed92c8&scoped=true"
import script from "./company_detail_base.vue?vue&type=script&lang=js"
export * from "./company_detail_base.vue?vue&type=script&lang=js"
import style0 from "./company_detail_base.vue?vue&type=style&index=0&id=3fed92c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fed92c8",
  null
  
)

export default component.exports